import React, { useEffect, useState } from "react";
import { Button, Badge, Row, Col, Container, Media } from "reactstrap";
import * as firebase from "firebase";
import Moment from "react-moment";

import { Tabs, Card } from "antd";

import { CardContent } from "semantic-ui-react";

import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { UserContext } from "../index";
import { Firestore, Auth } from "../config/firebase";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import pivot from "../Logic/Pivot/pivot";
import UpvoteDisplay from "../components/UpvotesDisplay";

export default function AllproductView(props) {
  const { TabPane } = Tabs;
  const { params } = props.match;

  const [data, setData] = useState([]);
  const [product, setProduct] = useState([]);
  const [comment, setComment] = useState("");

  useEffect(() => {
    async function fetchProduct() {
      var docRef = Firestore.collection("allProducts").doc(params.id);

      docRef
        .get()
        .then(function (doc) {
          console.log("doc", doc);
          if (doc.exists) {
            setProduct(doc.data());
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    }

    async function fetchallProducts() {
      Firestore.collection("allProducts")
        .get()
        .then(function (querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function (doc) {
            docs.push({ ...doc.data(), id: doc.id });
            // doc.data() is never undefined for query doc snapshots
          });

          setData(docs);
        });
    }

    // async function updateit() {
    //   const collection = await Firestore
    //     .collection("allProducts")
    //     .get()
    //   collection.forEach(doc=> {
    //     doc.ref
    //       .update({
    //         upvote_count: 0
    //       })
    //   })
    // }

    // updateit();
    fetchProduct();
    fetchallProducts();
  }, [params.id]);

  async function fetchallProducts() {
    Firestore.collection("allProducts")
      .get()
      .then(function (querySnapshot) {
        let docs = [];
        querySnapshot.forEach(function (doc) {
          docs.push({ ...doc.data(), id: doc.id });
          // doc.data() is never undefined for query doc snapshots
        });

        setData(docs);
      });
  }

  const handleUpvote = (id) => {
    if (Auth.currentUser) {
      pivot.UpVote(id);
    } else {
      props.history.push("/login");
    }
  };

  async function onUpvote(id) {
    Firestore.collection("allProducts")
      .doc(id)
      .collection("upvotes")
      .get()
      .then((snap) => {
        console.log(snap.length);
      });
    const user = Auth.currentUser;
    if (user) {
      Firestore.collection("allProducts")
        .doc(id)
        .update({ upvote_count: firebase.firestore.FieldValue.increment(1) });
      Firestore.collection("allProducts")
        .doc(id)
        .update({
          upvotes: firebase.firestore.FieldValue.arrayUnion({
            update_id: id,
            user_email: user.email,
            upvote_count: firebase.firestore.FieldValue.increment(1),
          }),
        });
      Firestore.collection("users")
        .doc(user.uid)
        .update({ upvote_count: firebase.firestore.FieldValue.increment(1) });

      Firestore.collection("allProducts")
        .doc(id)
        .update({
          upvotes: firebase.firestore.FieldValue.arrayUnion({
            user_id: user.uid,
            user_name: user.displayName,
            user_email: user.email,
            upvote_count: firebase.firestore.FieldValue.increment(1),
          }),
        });

      Firestore.collection("users")
        .doc(user.uid)
        .update({
          upvotes: firebase.firestore.FieldValue.arrayUnion({
            update_id: id,
          }),
        });

      fetchallProducts();
    } else {
      window.location.href = "/login";
    }
  }

  async function fetchProduct() {
    var docRef = Firestore.collection("allProducts").doc(params.id);

    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          setProduct(doc.data());
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        console.log("Error getting document:", error);
      });
  }

  async function submit() {
    console.log(comment);

    const user = Auth.currentUser;

    Firestore.collection("allProducts")
      .doc(params.id)
      .update({
        comments: firebase.firestore.FieldValue.arrayUnion({
          comment: comment,
          user_uid: user.uid,
          user_email: user.email,
          user_name: user.displayName,
          timestamp: Date.now(),
        }),
      })
      .then(fetchProduct());

    setComment("");
  }

  var settings = {
    arrow: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <UserContext.Consumer>
      {(value) => (
        <>
          <Navigation />

          <Container className="mt-5 mb-5">
            <Link to="/allproduct">
              <Button>
                {" "}
                <b>&#x2039;</b> Back to List
              </Button>
            </Link>

            <Row className="mt-3">
              <Col md={8} lg={8} sm={12}>
                <h2>{product.Title}</h2>
                <h6 className="mt-2">{product.Highlight}</h6>

                {product.Type && product.Type.map((type) => (
                  <>
                      <Badge href="#" style={{marginRight: 5, backgroundColor: `${product.color}` }}>{type}</Badge>
            
                  </>
                ))}
                <hr/>

                {/* <Card className="mt-3 mb-3"> */}
                  <Slider {...settings}>
                    {product.Image &&
                      product.Image.map((each, index) => (
                        <div>
                        
                          <img
                            key={index}
                            style={{ width: "100%", height: "100%" }}
                            src={each}
                          />
                        </div>
                      ))}
                  </Slider>
                {/* </Card> */}
                <hr/>

                <Card className="mb-3">
                  <div className="mb-2">{product.Description}</div>
                </Card>

                <Card className="mb-3">
                  <Tabs defaultActiveKey="1">
                  <TabPane tab={<span>Comments</span>} key="1">
                  <div className="col-md-9">
                    {value == '' ? <h3>You have to be logged in to leave a comment </h3> : (
                      <div className=" mb-4">
                        <textarea
                          className="form-control mb-2"
                          value={comment}
                          onChange={event => setComment(event.target.value)}
                        ></textarea>
                        <Button color="primary" onClick={submit}>
                          Comment
                        </Button>
                      </div>
                    )}

                    {product.comments &&
                      product.comments.map(item => (
                        <>
                          <Media
                            style={{
                              background: "rgb(252, 252, 252)",
                              marginBottom: 10,
                              padding: 14
                            }}
                          >
                            <Media left href="#" style={{ marginRight: 6 }}>
                              <Media
                                style={{
                                  background: "rgb(252, 252, 252)",
                                  marginBottom: 10,
                                  padding: 14,
                                }}
                              >
                                <Media left href="#" style={{ marginRight: 6 }}>
                                  <Media
                                    object
                                    style={{ height: "50px" }}
                                    src={
                                      "https://res.cloudinary.com/dqcsk8rsc/image/upload/v1577268053/avatar-1-bitmoji_upgwhc.png"
                                    }
                                    alt="Generic placeholder image"
                                  />
                                </Media>
                                <Media body>
                                  <Media heading>
                                    {item.user_name || item.user_email}
                                  </Media>
                                  <h6>
                                    <Moment fromNow>{item.timestamp}</Moment>{" "}
                                  </h6>
                                  <hr />

                                  <p className="pt-2">{item.comment}</p>
                                </Media>
                              </Media>
                              </Media>
                              </Media>
                            </>
                          ))}
                      </div>
                    </TabPane>
                  </Tabs>
                </Card>
              </Col>

              <Col md={4} lg={4} sm={12} className="text-center">
                <UpvoteDisplay history={props.history} postID={params.id} />

                {/* <div className="mb-2"><Button color="primary" rounded>Upvote</Button></div>
                <Button color="info" outline>Reviews</Button> */}

                <Card className="mt-4">
                  <h6>Website</h6>
                  <Button
                    className="btn-sm mt-2"
                    outline
                    color="primary"
                    onClick={() => window.open(product["Apply"])}
                  >
                    Click to visit Website
                  </Button>
                </Card>
              </Col>
            </Row>
          </Container>

          <Footer />
        </>
      )}
    </UserContext.Consumer>
  );
}
